export var isDifferentResponse = function (request, response) {
    if (!response.events || !response.events.length) {
        return false;
    }
    if (request.eventTags && request.eventTags.length && response.events[0].tags) {
        return response.events[0].tags.indexOf(request.eventTags[0]) === -1;
    }
    return checkDateRangeAndSportId(request, response);
};
var isDifferentDateRange = function (request, response) {
    if (request.dateRange) {
        return response.events && response.events.some(function (ev) {
            var date = new Date(ev.startEventDate ? ev.startEventDate : 0);
            return date < request.dateRange.from || date >= request.dateRange.to;
        });
    }
    return false;
};
var checkDateRangeAndSportId = function (request, response) {
    var dateRangeCheck = isDifferentDateRange(request, response);
    return dateRangeCheck || request.ids.indexOf(response.events && response.events[0].sportId) === -1;
};
//# sourceMappingURL=isDifferentResponse.js.map